import React from 'react';
import { ArrowRight, Sparkles, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[60vh] md:min-h-screen flex items-center pt-16 md:pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_opale-lavage/artifacts/7u6cqqjl_380096041_367559402265924_474358464635828499_n.jpg"
          alt="Lavage de fenêtres professionnel"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-3 py-1.5 mb-4 md:mb-8">
            <Sparkles className="text-cyan-400" size={16} />
            <span className="text-white text-xs md:text-sm font-medium">
              Service professionnel partout au Québec
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight">
            Vision claire.
            <br />
            <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-pink-500 bg-clip-text text-transparent">
              Résultats impeccables.
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-base md:text-xl text-gray-200 mb-6 md:mb-8 max-w-2xl">
            Lavage de fenêtres et bâtiments au Québec. Osmose écologique, soft wash et lavage à pression.
          </p>

          {/* Features - 2 columns compact on mobile */}
          <div className="grid grid-cols-2 gap-2 md:gap-4 mb-6 md:mb-10">
            <div className="flex items-center space-x-2">
              <CheckCircle2 className="text-cyan-400 flex-shrink-0" size={18} />
              <span className="text-white text-sm font-medium">Estimation gratuite</span>
            </div>
            <div className="flex items-center space-x-2">
              <CheckCircle2 className="text-cyan-400 flex-shrink-0" size={18} />
              <span className="text-white text-sm font-medium">Résultats garantis</span>
            </div>
            <div className="flex items-center space-x-2">
              <CheckCircle2 className="text-cyan-400 flex-shrink-0" size={18} />
              <span className="text-white text-sm font-medium">Service rapide</span>
            </div>
            <div className="flex items-center space-x-2">
              <CheckCircle2 className="text-cyan-400 flex-shrink-0" size={18} />
              <span className="text-white text-sm font-medium">Osmose écologique</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white text-base md:text-lg px-6 py-5 md:px-8 md:py-6 shadow-2xl transition-all transform hover:scale-105"
            >
              Obtenir une soumission
              <ArrowRight className="ml-2" size={18} />
            </Button>
            <Button
              onClick={scrollToServices}
              size="lg"
              className="bg-white text-gray-900 hover:bg-gray-100 text-base md:text-lg px-6 py-5 md:px-8 md:py-6 shadow-xl transition-all font-semibold"
            >
              Nos services
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
